const GET_PHOTO_INFO = 'GET_PHOTO_INFO';

export default {
  /** 写真情報 取得 */
  GET_PHOTO_INFO,
};
